import { UnknownAction, PayloadAction, createAction } from '@reduxjs/toolkit';

import type { AnyApi } from '../../buildCreateApi';
import type { TagDescription } from '../../rtk-query-types';

/**
 * Формат мета-информации в экшенах {reducerPath}/invalidateTags.
 * Экшен создается внутри RTK Query, но не экспортируется.
 */
export type InvalidateTagsAction = PayloadAction<TagDescription<string>[]>;

/**
 * Создает функцию-матчер, которая определяет является ли экшен инвалидацией тегов.
 * @param api Инстанс RTK Query API.
 * @returns Функция-матчер, которая определяет является ли экшен инвалидацией тегов.
 */
export function createInvalidateTagsActionMatcher<Api extends AnyApi>(api: Api) {
    const invalidateTagsAction = createAction(`${api.reducerPath}/invalidateTags`);

    return function (action: UnknownAction): action is InvalidateTagsAction {
        return invalidateTagsAction.match(action);
    };
}
